export const GET_TICKETS_URL = "https://api.quicksell.co/v1/internal/frontend-assignment";